<template>
  <div>
    <v-card class="mb-5">
      <v-toolbar dense color="teal" dark>
        <v-icon left>mdi-package-variant</v-icon>Stok Yönetimi
      </v-toolbar>
      <v-list>
        <div :key="key" v-for="(nav, key) in stokNav">
          <v-list-item color="teal" :to="`${nav.link}`">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-2">
                <v-icon left color="teal">{{nav.icon}}</v-icon>
                {{nav.name}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "StokNavigasyon",
  computed: {
    ...mapState({
      /**
       * @returns {Object}
       */
      stokNavigation: state => state.panelNavigation.child.stock
    }),
    /**
     * @returns {Array}
     */
    stokNav() {
      return this.stokNavigation.child
    }
  }
};
</script>

<style>
</style>